<app-page-data-panel
  title="Timesheets"
  subtitle="Review your captured time and submitted periods."
  [resultText]="timesheets.length + ' timesheets'">
  <div class="timesheet-summary">
    <div><span>Total periods</span><strong>{{ timesheets.length }}</strong></div>
    <div><span>Total hours</span><strong>{{ totalHours }}</strong></div>
  </div>

  @if (timesheets.length) {
    <p-table [value]="timesheets" responsiveLayout="stack" breakpoint="768px">
      <ng-template pTemplate="header">
        <tr>
          <th>Period</th>
          <th>Status</th>
          <th>Regular</th>
          <th>Overtime</th>
          <th>Drive / Duty</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-timesheet>
        <tr>
          <td><span class="p-column-title">Period</span>{{ timesheet.periodStart | date:'mediumDate' }} - {{ timesheet.periodEnd | date:'mediumDate' }}</td>
          <td><span class="p-column-title">Status</span><p-tag [value]="label(timesheet.timesheetStatus)" [severity]="statusSeverity(timesheet.timesheetStatus)"></p-tag></td>
          <td><span class="p-column-title">Regular</span>{{ timesheet.regularHours ?? 0 }}</td>
          <td><span class="p-column-title">Overtime</span>{{ timesheet.overtimeHours ?? 0 }}</td>
          <td><span class="p-column-title">Drive / Duty</span>{{ timesheet.driveDutyHours ?? 0 }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p class="empty-state">No timesheets available yet.</p>
  }
</app-page-data-panel>
